<template>
    <app-layout>
        <div class="row panel-container">

            <panel>
                <h2 slot="header">Mainīt materiālu</h2>

                <div class="panel-content">
                    <material-form v-if="material.id" :material.sync="material" ref="materialForm"></material-form>
                </div>

                <div slot="footer" style="width:100%;">
                    <button class="button hollow secondary float-left" @click="$router.go(-1)" type="button">Atpakaļ</button>
                    <button class="button success float-right" type="button" @click.prevent="submitMaterial()" :disabled="errors.any()">Iesniegt</button>
                </div>
            </panel>

        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../layouts/AppLayout'
    import Panel from '../components/Panel'
    import MaterialForm from '../components/materials/MaterialForm'
    import materials from '../api/materials'

    export default {

        props: ['id'],

        created() {
            this.getMaterial();
        },

        data() {
            return {
                material: {
                    id: null,
                    title: null,
                    uri: null,
                    type: null,
                    mime_type: null,
                    description: null,
                    signature_type: null,
                    categories: [],
                    file: null,
                }
            }
        },

        methods: {
            // Call material form submit handler directly
            submitMaterial(e) {
                this.$refs.materialForm.save();
            },

            getMaterial() {
                return materials.find(this.id)
                    .then(response => {
                        console.log('material loaded for form', this.material);
                        Object.assign(this.material, response.data.data);
                        return response;
                    })
            }
        },

        watch: {
            id: function (val, oldVal) {
                this.getMaterial();
            }
        },

        components: {AppLayout, Panel, MaterialForm}

    }
</script>

<style scoped>
    .panel-container {
        justify-content: space-evenly;
        vertical-align: middle;
        padding: 100px 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/MaterialEdit.vue